import {
  Button,
  Card,
  CardActionArea,
  CardContent,
  Checkbox,
  Grid,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setUser } from "../../features/auth/authSlice";
import { unsetAccount } from "../../features/registration/registrationSlice";
import { auth, db } from "../../utils/firebase/firebase";
import "./Registration.css";
function Registrationpg3() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isClick, setIsClick] = useState(false);
  const [hasAgreedToMarketing1, setHasAgreedToMarketing] = useState(false);
  const [hasAgreedToTermsAndConditions1, setHasAgreedToTermsAndConditions] =
    useState(false);
  const {
    email,
    firstName,
    lastName,
    password,

    sex,
    phone,
    province,
    cityTown,
    street,
    zipCode,
    refCode,
    isEighteen,
    occupation,
    usage,
  } = useSelector((state) => state.registration);
  const globalData = useSelector((state) => state.registration);
  // console.log(globalData);
  const handleOnChange = async (event) => {
    event.preventDefault();

    //
    try {
      const { user } = await auth.createUserWithEmailAndPassword(
        email,
        password
      );

      Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
      // console.log(user);

      let refStatus = false;

      if (refCode === "" || refCode === undefined) {
        refStatus = false;
      } else {
        refStatus = true;
      }

      var date = new Date();
      const dateMs = date * 1;
      const date90Days = dateMs + 3600000 * 24 * 90;
      // console.log(date.addDays(5));

      await db
        .collection("Users")
        .doc(user.uid)
        .set({
          appInfo: {
            lastAccessDate: "",
            lastIpAddress: "",
          },
          config: {
            dateCreated: new Date(),
            hasAgreedToTermsAndConditions: hasAgreedToTermsAndConditions1,
            hasAgreedToMarketing: hasAgreedToMarketing1,
            isEmailVerified: false,
            isMobileVerified: false,
            memberExpiry: new Date(date90Days),
            status: "pending",
            withReferral: refStatus,
          },
          details: {
            address: {
              cityTown: cityTown,
              province: province,
              streetAddress: street,
              zipCode: zipCode,
            },

            email: email,
            firstName: firstName,
            fullName: firstName + " " + lastName,
            lastName: lastName,
            mobile: phone,
            sex: sex,
            isAtleastEighteen: isEighteen,
          },
          usageData: { occupation: occupation, usage: usage },
          settings: {
            id: {
              link: "",
              type: "Id Type",
              uploadDate: "",
            },
            photo: "",
            referralCode: refCode,
            userType: "user",
          },
        });
      dispatch(
        setUser({
          email: user.email,
          uid: user.uid,
        })
      );
      dispatch(unsetAccount());
      navigate("/");
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    <>
      <Grid container spacing={2} direction="row" justifyContent="center">
        <Grid item xs="auto" sx={{ marginLeft: "5rem" }}>
          <Box className="card card--left">
            <Box className="card">
              <Box>
                <h1 className="card__title">Welcome to Tuos</h1>
              </Box>
              <Box>
                <Box mt="1.5em" />
                <p className="card__text">
                  In order to proceed with the platform, we would to get to know
                  you better.
                </p>
                <Box mt="1.5em" />
                <p className="card__text">This will only take 1 - 2mins.</p>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs="auto">
          <Box className="card card--right">
            <Box
              className="card"
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
            >
              <Box pt="0.5em" />
              <h4 className="textfield__text1">
                Lastly, please select your preferred package below
              </h4>
              <Box mt="3em" />
              <Box paddingRight={39}>
                <Card className={isClick ? "background-color-change" : ""}>
                  <CardActionArea
                    onClick={() => {
                      setIsClick(!isClick);
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",

                          alignItems: "center",
                        }}
                      >
                        <Typography
                          className={isClick ? "headerP3White" : "headerP3"}
                        >
                          EARLY BIRD
                        </Typography>
                        <Box
                          className={isClick ? "stateSelected" : "stateWhite"}
                        >
                          {isClick ? "Selected" : "Click here to select"}
                        </Box>
                      </Box>

                      <Typography
                        mt="1em"
                        className={isClick ? "subHeaderP3White" : "subHeaderP3"}
                      >
                        Get a FREE 90-Day Access
                      </Typography>
                      <Typography
                        mt="1em"
                        className={
                          isClick ? "miniSubHeaderP3White" : "miniSubHeaderP3"
                        }
                      >
                        As an early adopter of the platform, you'll get access
                        to the initial feature offered by Tuos for your data
                        analytics needs.
                      </Typography>
                      <Box mt="4em" />
                      <Typography
                        mt="1em"
                        className={isClick ? "disclaimerWhite" : "disclaimer"}
                      >
                        Disclaimer: &nbsp;
                        <i>
                          Alpha Tuos is still in it's early stage, If you
                          encounter any bug or errors while using the platfor or
                          if have any suggestion you want to see in the
                          platform, send us an email at info@asklexph.com
                        </i>
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Box>
              <h4 className="textfield__text1">Consent</h4>
              <Grid container mt={2} ml={0.1} spacing={1}>
                <Grid md={1}>
                  <Checkbox
                    onChange={(e) => {
                      setHasAgreedToTermsAndConditions(
                        !hasAgreedToTermsAndConditions1
                      );
                    }}
                  />
                </Grid>
                <Grid md={8}>
                  <Typography
                    color="text.secondary"
                    fontSize={15}
                    variant="h6"
                    mt={1.5}
                    className="checkbox-pg3 "
                  >
                    I have read and agreed on the{" "}
                    <a href="#">Terms of Service</a> and the{" "}
                    <a href="#">Privacy Policy</a>
                  </Typography>
                </Grid>
              </Grid>
              {/*  Agreed to marketing*/}
              <Grid container ml={0.1} spacing={1}>
                <Grid md={1}>
                  <Checkbox
                    onChange={(e) => {
                      setHasAgreedToMarketing(!hasAgreedToMarketing1);
                    }}
                  />
                </Grid>
                <Grid md={8}>
                  <Typography
                    color="text.secondary"
                    fontSize={15}
                    variant="h6"
                    mt={1.5}
                    className="checkbox-pg3 "
                  >
                    I agree to receive Marketing Materials from Asklex through
                    the contact details I've provided.
                  </Typography>
                </Grid>
              </Grid>
              <Box pb="2em" />
            </Box>
          </Box>
          <Grid container spacing={2} mt={2} ml="2rem">
            <Grid
              ml="19.2em"
              justify="space-between" // Add it here :)
              row
              spacing={24}
            >
              <Button
                variant="text"
                className="skip-button "
                onClick={() => {
                  navigate("/registrationPg3");
                }}
              >
                Skip
              </Button>
            </Grid>
            <Grid row md={1}>
              <Button
                variant="contained"
                className="success__button1"
                onClick={handleOnChange}
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default Registrationpg3;
